import moment from 'moment';
import i18n from 'i18next';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

export const fleetIconMapping = {
  'Tractor Day Cab': mediaUrls.tractorDayCab,
  'Tractor Sleeper': mediaUrls.tractorSleeper,
  Bobtail: mediaUrls.bobTail,
  'Straight Truck': mediaUrls.straightTruck,
  'Box Truck': mediaUrls.boxTruck,
  Pickup: mediaUrls.pickup,
  'Private Passenger': mediaUrls.privatePassenger,
  Vacuum: mediaUrls.vacuumTrailer,
  Van: mediaUrls.van,
  'Other Trailers': mediaUrls.otherTrailer,
  Flatbed: mediaUrls.flatBed,
  'Dry Van': mediaUrls.dryVan,
  Reefer: mediaUrls.reeferTrailer,
  Tanker: mediaUrls.tankerTrailer,
  Dump: mediaUrls.dump,
  Pneumatic: mediaUrls.pneumaticTrailer,
  'Other Vehicles': 'otherVehicle',
  Other: 'otherTrailer',
};

export const scoreCardItemDescription = {
  fleet: 'Fleet',
  address: 'Address',
  dotNumber: 'DOT Number',
  xDate: 'Insurance expiry date',
  reportDate: 'Report date',
  operatingTerritory: {
    overageStatus: 'Percentage of radius violations in each radius boundaries',
    isftaStatus: 'Mileage of vehicles per state',
  },
  quickStatus: {
    fleetManagementScore: 'A look at your company',
    vehicleInspectionScore: 'Quick look at your dvir history',
    consistentEquipment: 'How long you have used the same vehicles',
    vehicleComposition: 'Type of vehicles in your fleet',
    driverTurnOver: 'This is calculated by dividing employment length by the total number of drivers',
    driverTenure:
      'This is calculated by the total number of drivers hired in the current year (Decided based on the hire date) divided by the total number of drivers',
  },
  fleetManagement: 'Sum of active vehicles/trailers and inactive vehicle/tailer for the insurance period',
  radiusCompliance: 'List of radius compliance violations',
};

export const columns = [
  {
    id: 'driverName',
    disablePadding: false,
    label: i18n.t('scoreCard.radiusTable.driverName'),
    needSorting: true,
  },
  {
    id: 'vehicleName',
    disablePadding: false,
    label: i18n.t('scoreCard.radiusTable.vehicle'),
    needSorting: true,
  },
  {
    id: 'radiusCompliance',
    disablePadding: false,
    label: i18n.t('scoreCard.radiusTable.radius'),
    needSorting: true,
  },
  {
    id: 'radiusExperienced',
    disablePadding: false,
    label: i18n.t('scoreCard.radiusTable.radiusExperience'),
    needSorting: true,
  },
  {
    id: 'overage',
    disablePadding: false,
    label: i18n.t('scoreCard.radiusTable.overage'),
    needSorting: true,
  },
  {
    id: 'date',
    disablePadding: false,
    label: i18n.t('scoreCard.radiusTable.date'),
    needSorting: true,
  },
  {
    id: 'severityName',
    disablePadding: false,
    label: i18n.t('Severity'),
    needSorting: true,
  },
];

export const severityList = [
  {
    label: 'Less than 33%',
    value: 'LESS_THAN_33_PERCENTAGE',
  },
  {
    label: 'Between 33% to 67%',
    value: 'BETWEEN_33_TO_67_PERCENTAGE',
  },
  {
    label: 'Greater than 67%',
    value: 'GREATER_THAN_67_PERCENTAGE',
  },
];

export const getFleetIno = ({ i18n, scoreCard, insuracePortalUserRole }) => {
  return [
    {
      description: scoreCardItemDescription.fleet,
      title: insuracePortalUserRole ? i18n.t('policyHolder') : i18n.t('scoreCard.fleet'),
      value: scoreCard?.companyData?.companyName,
      icon: 'fleet',
    },
    {
      description: scoreCardItemDescription.address,
      title: i18n.t('scoreCard.address'),
      value: scoreCard?.companyData?.address,
      icon: 'location',
    },
    {
      description: scoreCardItemDescription.dotNumber,
      title: i18n.t('scoreCard.dotNumber'),
      value: scoreCard?.companyData?.dotNumber,
      icon: 'dot',
    },
    {
      description: scoreCardItemDescription.xDate,
      title: i18n.t('scoreCard.xDate'),
      value: scoreCard?.companyData?.insuranceExpDate ? moment(scoreCard?.companyData?.insuranceExpDate).format('MMM DD, YYYY') : '',
      icon: 'date',
    },
    {
      description: scoreCardItemDescription.reportDate,
      title: i18n.t('scoreCard.date'),
      value: moment().format('MMM DD, YYYY'),
      icon: 'date',
    },
  ];
};
